import GiftRegistryWithItemsSchema from "@apps/gift_registry/schemas/GiftRegistryWithItemsSchema";
import { array, object } from "superstruct";

const GiftRegistriesWithItemsResponseSchema = object({
    giftRegistriesWithItems: array(GiftRegistryWithItemsSchema),
});

export default GiftRegistriesWithItemsResponseSchema;
